import { Language } from '../../../enums/const-enums';

export interface RassEmailTranslations {
  inputLabel: string;
  inputPlaceholder: string;
  buttonLabel: string;
  valueMissing: string;
  typeMismatch: string;
  patternMismatch: string;
}

const nlTranslations: RassEmailTranslations = {
  inputLabel: 'E-mailadres',
  inputPlaceholder: 'voorbeeld@rabobank.nl',
  buttonLabel: 'Volgende',
  valueMissing: 'E-mailadres is verplicht.',
  typeMismatch: 'Geen geldig e-mailadres.',
  patternMismatch: 'Geen geldig e-mailadres.',
};

const enTranslations: RassEmailTranslations = {
  inputLabel: 'Email address',
  inputPlaceholder: 'example@rabobank.com',
  buttonLabel: 'Next',
  valueMissing: 'Email address is required.',
  typeMismatch: 'Invalid email address format.',
  patternMismatch: 'Invalid email address format.',
};

const esTranslations: RassEmailTranslations = {
  inputLabel: 'Correo electrónico',
  inputPlaceholder: 'ejemplo@rabobank.com',
  buttonLabel: 'Próximo',
  valueMissing: 'Correo electrónico es requerido.',
  typeMismatch: 'Su correo electrónico contine caracteres no permitidos.',
  patternMismatch: 'Su correo electrónico contine caracteres no permitidos.',
};

const ptTranslations: RassEmailTranslations = {
  inputLabel: 'E-mail',
  inputPlaceholder: 'exemplo@rabobank.com',
  buttonLabel: 'Próximo',
  valueMissing: 'E-mail é obrigatório.',
  typeMismatch: 'O endereço de e-mail não é válido.',
  patternMismatch: 'O endereço de e-mail não é válido.',
};

export const rassEmailTranslations = {
  [Language.NL]: nlTranslations,
  [Language.EN]: enTranslations,
  [Language.ES]: esTranslations,
  [Language.PT]: ptTranslations,
};
